module.exports = __webpack_public_path__ + "static/img/SeaScaffoldingLogo.9bfdc19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SeaScaffoldingLogo.png
// module id = sn3v
// module chunks = 1